<script lang="ts">
	import { SidepanelContent } from '@Shelly/shelly-design-system';
	import ScriptsV2 from 'src/components/DevicesSettings/Scripts/ScriptsG2V2.svelte';
	import type { Device } from 'src/types/Device.ts';

	export let device: Device;
</script>

<SidepanelContent>
	<ScriptsV2 {device} />
</SidepanelContent>
